export default {
  labels: {
    custom: 'Mukautettu – saatavilla pyynnöstä',
    was: 'Oli {{amount}} – vuosialennus käytetty',
  },
  tags: {
    preferred: 'Erityisen suosittu',
    net_one_time: 'netto, kertamaksu',
    annual_discount: '-{{percentage}} % vuosittain',
  },
  buttons: {
    select_plan: 'Valitse tämä paketti',
  },
};
